import React, {useState} from 'react';
import ProductVariant from "./ProductVariant";
import {useTranslation} from "react-i18next";
import {Collapse} from "react-bootstrap";
import {ReactComponent as ArrowDownIco} from "../../../../../../../images/icons/arrow-bottom.svg";
import {ReactComponent as ArrowUpIco} from "../../../../../../../images/icons/arrow-top.svg";

interface Props {
    productItemGroup: Record<string, any> | undefined;
    updateProductState: (productState: Record<string, any>) => void;
    productState: Record<string, any>;
    variants: { item: Record<string, any>; itemInfo: Record<string, any>; itemView: Record<string, any> }[];
    isProductAvailable: boolean;
}

const ProductVariants = ({
                             productItemGroup,
                             updateProductState,
                             productState,
                             variants,
                             isProductAvailable
                         }: Props) => {
    const {t} = useTranslation();
    const [showItems, setShowItems] = useState(true);

    if (!productItemGroup || variants.length < 2) return <></>;

    const getPriceDisplayMode = () => {
        const anyFreeItem = variants.some((variant: any) => !variant.itemInfo.price || variant.itemView.price.amount === 0);
        const anyNotFreeItem = variants.some((variant: any) => variant.itemInfo.price?.amount);

        if (anyFreeItem && anyNotFreeItem) return "mixed";

        if (anyFreeItem || !anyNotFreeItem) return "allFree";

        if (!anyFreeItem || anyNotFreeItem) return "allPaid";
    }

    return (
        <div>
            <fieldset className="form-group">
                <legend aria-live="polite">
                    <div className="d-flex align-items-center justify-content-between">
                        <h1 className="h5">
                            {t("modules.menu.field.choose_variant.title")}
                        </h1>
                        {
                            showItems ? <ArrowUpIco className="collapse-icon" onClick={() => setShowItems(false)}/> :
                                <ArrowDownIco className="collapse-icon" onClick={() => setShowItems(true)}/>
                        }
                    </div>
                </legend>
                <Collapse in={showItems}>
                    <div>
                        <div className="product-items-grid">
                            {variants.map((variant) => (
                                <ProductVariant key={`${productItemGroup.reference_id}-${variant.item.id}`}
                                                variant={variant}
                                                priceDisplayMode={getPriceDisplayMode()}
                                                updateProductState={updateProductState} productState={productState}
                                                isProductAvailable={isProductAvailable}
                                                productItemGroup={productItemGroup}/>
                            ))}
                        </div>
                    </div>
                </Collapse>
            </fieldset>
        </div>
    )
}

export default ProductVariants;